import { colorPaletteTheme as color } from './color';

export const formTheme = {
  default: color.grayScale.extraDark,
  active: color.primary,
  error: color.error,
} as const;
